import { useEffect, useState } from "react";
import { getReportSec, setReportSec } from "@/lib/api";

export function useReportSec() {
  const [sec, setSec] = useState(getReportSec());
  useEffect(() => {
    const on = () => setSec(getReportSec());
    window.addEventListener("mwjk-rsec", on);
    return () => { window.removeEventListener("mwjk-rsec", on); };
  }, []);
  return [sec, setReportSec];
}

export function ReportSecPicker({ testid = "report-sec-picker" }) {
  const [sec, setSec] = useReportSec();
  const opt = (k, label) => (
    <button key={k} type="button" onClick={() => setSec(k)} aria-pressed={sec === k} data-testid={`${testid}-${k}`}
      className={`rounded-full px-5 py-2 text-sm font-bold transition-colors ${sec === k ? "bg-[hsl(var(--primary))] text-white" : "bg-white text-slate-700 hover:bg-slate-100"}`}>{label}</button>
  );
  return (
    <div className="flex flex-wrap items-center gap-3 rounded-xl border-2 border-[hsl(var(--gold))] bg-[hsl(var(--sand))] p-3" data-testid={testid}>
      <span className="text-sm font-semibold text-slate-800">Report settings for:</span>
      <div className="flex gap-1 rounded-full border border-slate-300 bg-white p-1">{opt("gc", "General Council")}{opt("mwjk", "MWJK")}</div>
      <span className="text-xs text-slate-600">Changes here apply only to {sec === "gc" ? "General Council" : "MWJK"}.</span>
    </div>
  );
}
